<!-- @veltra/icons generated sha256:9b1ee1063f38e02a gen:8 source:src/svg/normal/mobile.svg -->
<script setup lang="ts">
defineOptions({ name: 'Mobile' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
    <path d="M12 18h.01" />
  </svg>
</template>
